<div class="row my-md-5 pt-md-3 my-4 pt-2 pb-lg-4 justify-content-center" [ngBusy]="busy">
  <div class="col-12 text-center">
      <div class="section-title">
          <img [src]="getImageSource()" width="150">
          <h4 class="title mb-4" *ngIf="status === 2">{{ 'SuccessOperationMessage' | translate}}</h4>
          <h4 class="title mb-4" *ngIf="status === 3">{{ 'QuotationAnnulationMessage'  | translate }}</h4>

  </div>
  <p class="text-muted para-desc mx-auto" *ngIf="status === 2"> {{'QuotationValidationMessage' | translate}} </p>
</div>